import { Playlist } from '@raydiant/api-client-js';

export const shouldHideCompletedAutoRemovePlaylist = (
  playlist?: Playlist | null,
) => {
  if (!playlist?.startDatetime || !playlist?.endDatetime) return false;
  if (!playlist.autoRemoveOnScheduleEnd) return false;
  if (playlist.recurrenceRule) return false;

  const endMs = Date.parse(playlist.endDatetime);
  if (Number.isNaN(endMs)) return false;

  return endMs < Date.now();
};
